import React, {useCallback} from 'react'
import clsx from 'clsx'
import styles from './Switch.scss'

export type StatusType = 'on' | 'off'

export type SwitchProps = {
  status?: StatusType
  onClick: (newStatus: StatusType) => void
}

export const Switch: React.FC<SwitchProps> = props => {
  const { status = 'on', onClick } = props

  const handleClick = useCallback(() => {
    const newStatus = status === 'on' ? 'off' : 'on'
    onClick(newStatus)
  }, [status])

  return (
    <div className={clsx(styles.switchBtn, status === 'on' && styles.switchOn)} onClick={handleClick} />
  )
}
